"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeType = void 0;
var ChangeType;
(function (ChangeType) {
    ChangeType[ChangeType["Create"] = 0] = "Create";
    ChangeType[ChangeType["Delete"] = 1] = "Delete";
    ChangeType[ChangeType["Update"] = 2] = "Update";
    ChangeType[ChangeType["Unknown"] = 3] = "Unknown";
})(ChangeType || (exports.ChangeType = ChangeType = {}));
//# sourceMappingURL=firestore.js.map